const DEFAULT_DURATION_FIX_PREFIX_MIN_BYTES = 1024 * 1024;
const DEFAULT_DURATION_FIX_PREFIX_MAX_CHUNKS = 8;

export const getDurationFixPrefixChunkCount = (
    chunks: Blob[],
    {
        minBytes = DEFAULT_DURATION_FIX_PREFIX_MIN_BYTES,
        maxChunks = DEFAULT_DURATION_FIX_PREFIX_MAX_CHUNKS,
    }: {
        minBytes?: number;
        maxChunks?: number;
    } = {}
) => {
    let totalBytes = 0;
    let chunkCount = 0;

    for (const chunk of chunks.slice(0, maxChunks)) {
        totalBytes += chunk.size;
        chunkCount += 1;

        if (totalBytes >= minBytes) {
            break;
        }
    }

    return chunkCount;
};
